import { Box, Text, CheckBox } from 'grommet';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setShowCloserFields } from '../../../../redux/actions/map-actions/map-action';
import { verifyNearFields, verifyOverlap } from '../../../../redux/actions/map-actions/field/field-action';
import { useParams } from 'react-router-dom';
import { useAppSelector } from '../../../../redux';

export const ShowCloserFieldsComponents = (): JSX.Element => {
  const { t } = useTranslation();
  const { journeyId } = useParams();
  const dispatch = useDispatch();
  const loading = useAppSelector((state) => state.map.loadingFields);
  const showCloserFields = useAppSelector((state) => state.map.showCloserFields);
  const fields = useAppSelector((state) => state.map.fields);

  return (
    <Box
      style={{
        padding: '0px 8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 11,
        background: '#fff',
        border: 'solid 1px #282828',
        borderRadius: '5px',
      }}>
      <Box align='center'>
        <CheckBox
          data-cy={'toggle-close-fields'}
          disabled={loading}
          label={<Text style={{ display: 'flex', alignItems: 'center', fontSize: '12px', fontWeight: 700 }}>{t('fieldFlow.seeCloserFields')}</Text>}
          checked={showCloserFields}
          reverse={true}
          onChange={async (event) => {
            dispatch(setShowCloserFields(event.target.checked));
            if (event.target.checked) {
              dispatch(verifyOverlap(journeyId, fields));
              dispatch(verifyNearFields(journeyId, fields, t));
            }
          }}
          toggle
        />
      </Box>
    </Box>
  );
};
